export const DS_DRAG_HANDLE_CLASSES = {
  DragHandle: "ds-drag-handle",
} as const;
